export const permisA1Data = {
  path: '/permis-a1',
  breadcrumb: [
    ['Formations 2 & 3 roues', '/formation'],
    ['Permis A1', '/permis-a1'],
  ],
  kicker: 'Permis moto · 125 cm³ · dès 16 ans',
  title: 'Permis A1',
  titleHighlight: 'la moto à 16 ans.',
  subtitle:
    'Le permis A1 te permet de conduire une moto jusqu\'à 125 cm³ et 11 kW dès 16 ans. ETM + plateau + circulation, en moto-école agréée.',
  seoTitle: 'Permis A1 — Code moto + plateau + circulation · 125 cm³ dès 16 ans',
  seoDescription:
    'Le guide officiel pour passer le permis A1 (moto 125 cm³) à 16 ans : conditions, déroulement, durée, prix, ETM, plateau, circulation. Conseils ECSR.',
  seoKeywords:
    'permis a1, permis moto 16 ans, permis 125, moto 125 cm3, ETM permis a1, plateau permis a1, circulation permis a1, permis moto jeune',
  heroImage:
    'https://images.unsplash.com/photo-1558981852-426c6c22a060?w=2400&q=85&auto=format&fit=crop',
  heroImageAlt: 'Jeune motard sur sa 125 — permis A1',
  duration: '20 heures minimum (théorie + pratique)',
  cost: '~ 700 à 1 100 € selon moto-école',
  timeRequired: 'PT20H',
  about: 'Permis A1, moto 125 cm³, ETM, plateau, circulation',
  primaryCta: { label: 'Réviser l\'ETM', to: '/revision' },
  secondaryCta: { label: 'Voir le plateau', to: '/epreuves/plateau' },
  relatedTopic: 'permis-a1-a2',

  intro:
    "<p>Le <strong>permis A1</strong> est le permis moto accessible <strong>dès 16 ans</strong>. Il autorise la conduite d'une moto jusqu'à <strong>125 cm³</strong> et <strong>11 kW</strong> (≈ 15 ch). C'est l'étape idéale pour passer du <em>cyclomoteur</em> (50 cm³, permis AM/BSR) à la vraie <em>moto</em>.</p><p>L'examen comprend trois épreuves distinctes : l'<strong>ETM</strong> (Code moto, théorique), l'épreuve <strong>plateau</strong> (6 manœuvres officielles à basse et haute vitesse), et la <strong>circulation</strong> (30 min en conditions réelles). La formation se fait en moto-école agréée, avec un minimum légal de 20 heures de pratique.</p>",

  conditions: [
    {
      title: 'Avoir 16 ans révolus',
      text: 'Âge minimum strict le jour de l\'examen plateau et circulation. Tu peux préparer l\'ETM dès 15 ans 6 mois pour anticiper.',
    },
    {
      title: 'ASSR 2 obligatoire',
      text: 'Attestation Scolaire de Sécurité Routière niveau 2 (passée en classe de 3ᵉ). Sans ASSR, l\'inscription est refusée.',
    },
    {
      title: 'Visite médicale (parfois)',
      text: 'Pour certains cas spécifiques (problème de santé déclaré, lunettes obligatoires...). À vérifier avec ta moto-école.',
    },
    {
      title: 'Aptitude physique',
      text: 'Pas de prérequis sportif particulier, mais tu dois pouvoir tenir une 125 cm³ debout (≈ 130 kg). À tester avant inscription.',
    },
  ],

  steps: [
    {
      title: 'Choisir une moto-école agréée',
      duration: '1 jour',
      text: 'Vérifie l\'agrément préfectoral, le label \"Qualité des formations au sein des écoles de conduite\", les avis Google et le tarif total (forfait + heures supplémentaires).',
    },
    {
      title: 'Réviser et passer l\'ETM',
      duration: '4 à 8 semaines',
      text: 'Code moto officiel : 9 thèmes, 40 questions à l\'examen, 30€. Tu peux le préparer entièrement en autonomie sur CODE 2 ROUES (gratuit) avant de t\'inscrire à l\'examen en centre.',
    },
    {
      title: 'Formation pratique (20h minimum)',
      duration: '4 à 8 semaines',
      text: '8 heures plateau (manœuvres lentes + freinage + slalom + évitement) + 12 heures circulation (ville, campagne, voies rapides, conditions variées).',
    },
    {
      title: 'Examen plateau',
      duration: '15 minutes',
      text: '6 manœuvres officielles évaluées A (favorable), B (à reprendre) ou C (défavorable). Tu dois avoir A à toutes les manœuvres pour valider le plateau.',
    },
    {
      title: 'Examen circulation',
      duration: '30 minutes',
      text: '30 minutes de conduite réelle avec un inspecteur. Évaluation sur 31 critères : trajectoires, allure, observation, anticipation, courtoisie. Note de 17/31 minimum pour réussir.',
    },
  ],

  erreurs: [
    {
      title: 'Choisir une moto-école au prix le plus bas',
      text: 'Les forfaits low-cost ajoutent souvent 50€/heure supplémentaire. Vise plutôt un forfait clair avec heures supplémentaires < 45€.',
    },
    {
      title: 'Sous-estimer le plateau',
      text: 'Le plateau échoue 1 candidat sur 3 au premier passage. Allure lente et évitement à allure élevée demandent beaucoup d\'entraînement.',
    },
    {
      title: 'Négliger l\'équipement',
      text: 'Casque + gants + blouson + pantalon + chaussures montantes obligatoires. Sans équipement complet, tu ne passes pas l\'examen.',
    },
    {
      title: 'Stresser le jour J',
      text: 'L\'inspecteur n\'est pas là pour te piéger. Respire, prends ton temps, applique la méthode apprise en cours.',
    },
  ],

  conseils: [
    'Commence l\'ETM en autonomie 1-2 mois avant l\'inscription en moto-école : tu gagnes du temps et de l\'argent.',
    'Achète ton équipement avant les premières heures de plateau : tu seras plus à l\'aise et plus confiant.',
    'Filme-toi (avec autorisation moniteur) sur les manœuvres plateau : tu repères tes erreurs en quelques visionnages.',
    'Visite la piste plateau de ton centre d\'examen avant le jour J : ça enlève une part de stress.',
    'En cas d\'échec : 24h minimum pour repasser. Profites-en pour reprendre les points faibles.',
  ],

  faq: [
    {
      q: 'Quel est l\'âge minimum pour passer le permis A1 ?',
      a: '16 ans révolus le jour de l\'examen plateau et circulation. Tu peux préparer l\'ETM (Code moto) dès 15 ans 6 mois.',
    },
    {
      q: 'Quelle moto puis-je conduire avec le permis A1 ?',
      a: 'Une moto jusqu\'à 125 cm³ et 11 kW (15 ch). Tu ne peux pas conduire une 250, 600 ou 1000 cc avec le A1. Pour les motos plus grosses, il te faut le permis A2 (à 18 ans).',
    },
    {
      q: 'Combien coûte le permis A1 en moyenne ?',
      a: 'Entre 700 et 1 100 € selon les régions et les moto-écoles. Le forfait inclut généralement 20 heures de pratique + un passage examen plateau et circulation. Heures supplémentaires : 35-50 €/h.',
    },
    {
      q: 'Combien d\'heures de pratique sont obligatoires ?',
      a: '20 heures minimum légales (8h plateau + 12h circulation). En réalité, la moyenne est de 25-30 heures pour atteindre le niveau examen. Plus tu as d\'expérience préalable (vélo, scooter), plus c\'est rapide.',
    },
    {
      q: 'Que se passe-t-il si je rate le plateau ou la circulation ?',
      a: 'Tu peux repasser uniquement l\'épreuve échouée. Le plateau et la circulation sont indépendants. Délai minimum : 24h. Si tu valides le plateau et rates la circulation (ou inverse), seule l\'épreuve échouée est à repasser.',
    },
    {
      q: 'Le permis A1 me donne-t-il droit au permis A2 plus tard ?',
      a: 'Oui ! Si tu as le permis A1 depuis 2 ans, tu peux passer une formation passerelle A1→A2 de 7 heures (2h théorie + 2h plateau + 3h circulation) à partir de 18 ans, sans examen final.',
    },
  ],

  sourceLabel:
    'Code de la route, articles R211-1 à R211-5, programme officiel ETM 2026 (REMC), Sécurité routière.',
  sourceUrl: 'https://www.securite-routiere.gouv.fr/passer-son-permis-de-conduire/permis-moto',
};
